var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgAlertActive = function SvgAlertActive(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    "aria-hidden": true,
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8c0-4.387-3.613-8-8-8-4.42 0-8 3.613-8 8 0 4.42 3.58 8 8 8 4.387 0 8-3.58 8-8M8 9.613a1.5 1.5 0 0 1 1.484 1.484A1.48 1.48 0 0 1 8 12.58a1.46 1.46 0 0 1-1.484-1.484A1.48 1.48 0 0 1 8 9.613M6.58 4.29c-.032-.225.162-.419.388-.419H9c.226 0 .42.194.387.42l-.226 4.386c-.032.226-.193.355-.387.355h-1.58c-.194 0-.355-.129-.388-.355z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlertActive);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;